import { useState } from 'react';
import { Select } from './ui/select';
import { Input } from './ui/input';
import { Button } from './ui/button';

// Requestor picker: choose any user, or add an external requester inline.
// `value` is a user id string ('' = unassigned). Reports changes via onChange(id).
export default function RequestorField({ members, value, onChange, onCreateExternal }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSelect = (e) => {
    if (e.target.value === '__new__') {
      setAdding(true);
      return;
    }
    onChange(e.target.value);
  };

  const handleAdd = async () => {
    if (!name.trim() && !email.trim()) return;
    setBusy(true);
    try {
      const user = await onCreateExternal(name.trim(), email.trim());
      onChange(String(user.id));
      setAdding(false);
      setName('');
      setEmail('');
    } catch (err) {
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  const cancel = () => { setAdding(false); setName(''); setEmail(''); };

  // Most-used requestors first (so the usual suspects are at the top), then the
  // never-used ones alphabetically.
  const ordered = [...members].sort(
    (a, b) => (b.requested_count || 0) - (a.requested_count || 0) || a.name.localeCompare(b.name),
  );

  return (
    <div className="space-y-2">
      <Select value={adding ? '__new__' : value} onChange={handleSelect}>
        <option value="">Unassigned</option>
        {ordered.map((m) => (
          <option key={m.id} value={String(m.id)}>
            {m.name}{m.is_external ? ' (external)' : ''}
          </option>
        ))}
        <option value="__new__">+ Add external requester…</option>
      </Select>

      {adding ? (
        <div className="space-y-2 rounded-md border border-border bg-muted/30 p-2">
          <div className="grid gap-2 sm:grid-cols-2">
            <Input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} autoFocus />
            <Input type="email" placeholder="Email (optional)" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="flex gap-2">
            <Button type="button" onClick={handleAdd} disabled={busy}>{busy ? 'Adding…' : 'Add requester'}</Button>
            <Button type="button" variant="outline" onClick={cancel} disabled={busy}>Cancel</Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
